export const WEBSITE_DETAILS = {
  name: "WebCraft Pro",
  description:
    "Professional web design and SEO services that drive real results for your business.",
  tagline: "Grow your business with modern web design, high-converting UI development, and powerful SEO strategies. WebCraft Pro builds fast, responsive, and SEO-ready websites tailored to your brand.",
  slogan: "Crafted for growth",
  author: "Pankaj Kumar",
  contact: {
    email: "pankaj.syal1@gmail.com",
    phone: "+919478629522",
    otherPhone: "+91 7986207327",
    address:
      "Village Balahar P.O Rangas Tehsil Nadaun District Hamirpur Himachal Pradesh India",
    zipCode: "177048",
    country: "India",
  },
  socialMedia: {
    facebook: "https://www.facebook.com/Pankaj.syal592",
    twitter: "https://x.com/pankajk76520654",
    instagram: "https://instagram.com/webcraftpro",
    github: "https://github.com/Pankajsyal1",
    linkedin: "https://www.linkedin.com/in/pankaj-kumar-a1641ba6/",
    stackoverflow: "https://stackoverflow.com/users/27401510/pankaj-syal",
    whatsapp: "https://api.whatsapp.com/send/?phone=919478629522&text=Hi%2C+I%27m+interested+in+creating+a+professional+website+for+my+business.+Can+you+share+details+about+pricing%2C+timelines%2C+and+how+we+can+get+started%3F",
    telegram: "https://telegram.me/panku522",
  },
  businessHours: "Mon-Fri 00:00 - 23:59",
  websiteURL: "https://webdesign-lead-gen.vercel.app/",
  portfolioURL: "https://pankaj-portfolio-reactjs.vercel.app/",
  blogUrl: "https://reepank-blogs.vercel.app/",
  webAppeWebsite:
    "https://web-apps-portfolio-website.vercel.app/",
  mobileAppWebsite: "https://mobile-portfolio-complete.vercel.app/",
  mainWebsite: "https://reepank-solutions.vercel.app/",
  telTo: "tel:+919478629522",
  mailTo: "mailto:pankaj.syal1@gmail.com",
  full_year: `2022-${new Date().getFullYear()}`,
  mapIframe: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d54297.616131861374!2d76.40493271256841!3d31.7267923744501!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391b2dd2457714ff%3A0x1340e2bc28891980!2sBalahar!5e0!3m2!1sen!2sin!4v1765008198501!5m2!1sen!2sin"
};

export const EFFECTIVE_DATE = "September 13, 2025";
export const TESTIMONIALS_SKELTON_CARD_COUNT = 4;
export const STAR_COUNT_LENGTH = 5;
export const PORTFOLIO_SKELTON_CARD_COUNT = 3;

